import { Box, Grid } from "@material-ui/core";
import React from "react";
import RetailComplexion from "./RetailComplexion";
import RetailComplexionSeriesToggle from "./RetailComplexionSeriesToggle";

const BrandMix: React.FC = () => {
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <RetailComplexionSeriesToggle />
                </Grid>
                <Grid item xs={12}>
                    <RetailComplexion />
                </Grid>
            </Grid>
        </Box>
    );
};

export default BrandMix;
